jQuery(document).ready(function($) {
    // Only initialize if the products container exists on the page
    if ($('.mad-products__container').length === 0) {
        return;
    }

    // Type filter click
    $('.mad-products__filter-types .mad-products__filter-link').click(function(e) {
        e.preventDefault();
        
        $('.mad-products__filter-types .mad-products__filter-link').removeClass('active');
        $(this).addClass('active');
        
        var type = $(this).data('type') || '';
        var category = $('.mad-products__filter-categories .mad-products__filter-link.active').data('category') || '';
        var sort = $('.mad-products__sort-select').val() || 'recommended';
        
        filterProducts(type, category, sort);
    });
    
    // Category/Theme filter click
    $('.mad-products__filter-categories .mad-products__filter-link').click(function(e) {
        e.preventDefault();
        
        $('.mad-products__filter-categories .mad-products__filter-link').removeClass('active');
        $(this).addClass('active');
        
        var type = $('.mad-products__filter-types .mad-products__filter-link.active').data('type') || '';
        var category = $(this).data('category') || '';
        var sort = $('.mad-products__sort-select').val() || 'recommended';
        
        filterProducts(type, category, sort);
    });
    
    // Sort functionality
    $('.mad-products__sort-select').change(function() {
        var sortValue = $(this).val() || 'recommended';
        var type = $('.mad-products__filter-types .mad-products__filter-link.active').data('type') || '';
        var category = $('.mad-products__filter-categories .mad-products__filter-link.active').data('category') || '';
        
        filterProducts(type, category, sortValue);
    });
    
    function filterProducts(type, category, sort) {
        // Validate inputs with defaults
        type = type || '';
        category = category || '';
        sort = sort || 'recommended';
        
        var $productsGrid = $('.mad-products__grid');
        if (!$productsGrid.length) {
            console.error('Products grid container not found');
            return;
        }
        
        $productsGrid.addClass('loading');
        $productsGrid.append('<div class="mad-products__loading-overlay"><div class="mad-products__loading-spinner"></div></div>');
        
        // Update URL hash
        try {
            var hashState = [];
            if (type) hashState.push('type=' + encodeURIComponent(type));
            if (category) hashState.push('category=' + encodeURIComponent(category));
            if (sort) hashState.push('sort=' + encodeURIComponent(sort));
            
            if (hashState.length > 0) {
                window.location.hash = hashState.join('&');
            } else {
                history.replaceState("", document.title, window.location.pathname + window.location.search);
            }
        } catch (error) {
            console.error('Error updating URL hash:', error);
        }
        
        // Check if AJAX object exists
        if (typeof mad_ajax_obj === 'undefined' || !mad_ajax_obj.ajax_url) {
            console.error('AJAX configuration missing');
            $productsGrid.removeClass('loading');
            $('.mad-products__loading-overlay').remove();
            $productsGrid.html('<p class="mad-products__no-results">Konfigurationsfehler. Bitte laden Sie die Seite neu.</p>');
            return;
        }
        
        // Make AJAX request
        $.ajax({
            url: mad_ajax_obj.ajax_url,
            type: 'POST',
            data: {
                action: 'mad_filter_products',
                type: type,
                category: category,
                sort: sort,
                nonce: mad_ajax_obj.nonce || ''
            },
            timeout: 20000,
            success: function(response) {
                try {
                    if (response && response.success) {
                        $productsGrid.html(response.data.html || '');
                        
                        if (response.data.count !== undefined) {
                            $('.mad-products__count').text(response.data.count + ' Produkte gefunden');
                        }
                    } else {
                        console.error('Error filtering products:', response ? response.data : 'Invalid response');
                        $productsGrid.html('<p class="mad-products__no-results">Fehler beim Filtern der Produkte. Bitte versuchen Sie es erneut.</p>');
                    }
                } catch (error) {
                    console.error('Error processing AJAX response:', error);
                    $productsGrid.html('<p class="mad-products__no-results">Fehler beim Verarbeiten der Daten. Bitte versuchen Sie es erneut.</p>');
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', status, error);
                var errorMessage = 'Ein Fehler ist aufgetreten. ';
                
                if (status === 'timeout') {
                    errorMessage += 'Die Anfrage hat zu lange gedauert. ';
                } else if (xhr.status === 403) {
                    errorMessage += 'Zugriff verweigert. ';
                } else if (xhr.status === 404) {
                    errorMessage += 'Server-Endpunkt nicht gefunden. ';
                } else if (xhr.status >= 500) {
                    errorMessage += 'Serverfehler. ';
                }
                
                errorMessage += 'Bitte versuchen Sie es später erneut.';
                $productsGrid.html('<p class="mad-products__no-results">' + errorMessage + '</p>');
            },
            complete: function() {
                $productsGrid.removeClass('loading');
                $('.mad-products__loading-overlay').remove();
            }
        });
    }
    
    function handleInitialState() {
        try {
            if (window.location.hash) {
                var hash = window.location.hash.substring(1);
                var params = {};
                
                hash.split('&').forEach(function(param) {
                    try {
                        var parts = param.split('=');
                        if (parts.length === 2) {
                            params[parts[0]] = decodeURIComponent(parts[1]);
                        }
                    } catch (error) {
                        console.error('Error parsing hash parameter:', param, error);
                    }
                });
                
                if (params.type) {
                    var $typeLink = $('.mad-products__filter-types .mad-products__filter-link[data-type="' + params.type + '"]');
                    if ($typeLink.length) {
                        $('.mad-products__filter-types .mad-products__filter-link').removeClass('active');
                        $typeLink.addClass('active');
                    }
                }
                
                if (params.category) {
                    var $categoryLink = $('.mad-products__filter-categories .mad-products__filter-link[data-category="' + params.category + '"]');
                    if ($categoryLink.length) {
                        $('.mad-products__filter-categories .mad-products__filter-link').removeClass('active');
                        $categoryLink.addClass('active');
                    }
                }
                
                if (params.sort) {
                    $('.mad-products__sort-select').val(params.sort);
                }
                
                filterProducts(params.type || '', params.category || '', params.sort || 'recommended');
            }
        } catch (error) {
            console.error('Error handling initial state:', error);
            filterProducts('', '', 'recommended');
        }
    }
    
    // Initialize on page load
    handleInitialState();
    
    // Handle browser back/forward navigation
    $(window).on('hashchange', function() {
        try {
            handleInitialState();
        } catch (error) {
            console.error('Error handling hash change:', error);
        }
    });
});